import { makeAutoObservable, runInAction } from 'mobx';
import {

  FinancialPaymentParams,
  IFinancialPayment,

} from 'src/@types/Choqorak/MainTables/FinancialPayment/FinancialPayment';
import agent from 'src/api/agent';
export default class FinancialPaymentStore {
  openDialog = false;

  FinancialPaymentRegistry = new Map<number, IFinancialPayment>();

  editMode = false; //When click on edit button

  selectedFinancialPayment: IFinancialPayment | undefined = undefined;

  totalRecord: number = 0;

  // FinancialPaymentReportResult: IncomReportData | undefined;

  selectedFinancialPaymentDetail: IFinancialPayment | undefined;

  // FinancialPaymentChartData: FinancialPaymentChart | undefined;

  ID: any = localStorage.getItem('id');

  constructor() {
    makeAutoObservable(this);
  }

  get FinancialPaymentList() {
    return Array.from(this.FinancialPaymentRegistry.values());
  }

  setFinancialPaymentList = (FinancialPayment: IFinancialPayment) => {
    this.FinancialPaymentRegistry.set(FinancialPayment.financialPaymentId!, FinancialPayment);
  };

  //Pagination
  loadFinancialPayment = async (params: FinancialPaymentParams) => {
    // this.FinancialPaymentRegistry.clear();
    try {
      const result = await agent.FinancialPayment.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setFinancialPaymentList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  FinancialPaymentSearch = async (params: FinancialPaymentParams) => {
    this.FinancialPaymentRegistry.clear();
    this.loadFinancialPayment(params);
  };

  getFinancialPaymentFromRegistry = (id: number) => {
    let FinancialPayment = this.FinancialPaymentRegistry.get(id);
    if (FinancialPayment) {
      this.editMode = true;
      this.selectedFinancialPayment = FinancialPayment;
    }
  };

  clearSelectedFinancialPayment = () => {
    this.editMode = false;
    this.selectedFinancialPayment = undefined;
    this.selectedFinancialPaymentDetail = undefined;
  };

  deleteFinancialPayment = async (id: number, remark?: string) => {
    await agent.FinancialPayment.delete(id, remark!);
    runInAction(() => {
      this.FinancialPaymentRegistry.delete(id);
      this.totalRecord--;
      this.setOpenCloseDialog();
    });
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createFinancialPayment = async (FinancialPayment: IFinancialPayment) => {
    console.log(FinancialPayment);
    await agent.FinancialPayment.create(FinancialPayment, FinancialPayment.attachment);
    runInAction(() => {
      // this.loadFinancialPayment({ pageIndex: 0, pageSize: 5 });
      // this.clearSelectedFinancialPayment();
    });
  };

  updateFinancialPayment = async (FinancialPayment: IFinancialPayment) => {
    await agent.FinancialPayment.update(FinancialPayment, FinancialPayment.attachment);

    runInAction(() => {
      this.loadFinancialPayment({ pageIndex: 0, pageSize: 5 });
      this.FinancialPaymentRegistry.delete(FinancialPayment.financialPaymentId!);
      this.FinancialPaymentRegistry.set(FinancialPayment.financialPaymentId!, FinancialPayment);
      this.clearSelectedFinancialPayment();
    });
  };

  loadFinancialPaymentDetail = async (id: number) => {
    try {
      const getFinancialPaymentDetail = await agent.FinancialPayment.getDetail(id);
      runInAction(() => {
        this.selectedFinancialPaymentDetail = getFinancialPaymentDetail;
      });
    } catch (error) { }
  };

  // loadFinancialPaymentReport = async (reportParams: FinancialPaymentParams) => {
  //   // console.log(reportParams);
  //   const axiosResponse = await agent.FinancialPayment.getIncomReport(reportParams);

  //   runInAction(() => {
  //     this.FinancialPaymentReportResult = axiosResponse.data;
  //   });
  // };

  //#region RealTimeDashboard
  // LoadFinancialPaymentChart = async () => {
  //   try {
  //     const dashboardData = await agent.FinancialPayment.FinancialPaymentChartChart();
  //     runInAction(() => {
  //       if (dashboardData) {
  //         this.FinancialPaymentChartData = dashboardData.data;
  //       }
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  //#endregion
}
